var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 126,
    viewBox: "0 0 188 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.91 15.2998L144.65 43.9598L126.64 83.1898L119.17 42.0898L130.91 15.2998Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55 45.7696L148.1 29.6396L148.72 64.6197L130.55 45.7696Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.97 46.4496L148.36 44.7096L148.1 29.6396L158.52 33.9496L163.97 46.4496Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.021 85.0595C126.021 85.0595 148.38 64.7295 148.72 64.6195C149.06 64.5095 130.561 45.7695 130.561 45.7695L126.021 85.0595Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2305 56.4201L130.38 45.8301L126.021 85.0601L99.2305 56.4201Z",
    fill: "#FFA94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3301 97.73L114.3 72.21L126.02 85.06L96.3301 97.73Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38 45.8298L99.2305 56.4198V15.2998L130.38 45.8298Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.719 76.8403L178.599 68.3203L174.27 77.8803L184.719 76.8403Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62 120.59C137.2 120.59 136.78 120.43 136.46 120.11L133.45 117.1C132.81 116.46 132.81 115.42 133.45 114.78C134.09 114.14 135.13 114.14 135.77 114.78L138.78 117.79C139.42 118.43 139.42 119.47 138.78 120.11C138.46 120.43 138.04 120.59 137.62 120.59Z",
    fill: "#FFA94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.963 120.471L107.484 118.717L105.73 123.195L110.208 124.95L111.963 120.471Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66052 60.8601L1.65051 56.6201L0.980469 63.9401L7.66052 60.8601Z",
    stroke: "#FFA94D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2197 12.2402L33.1298 25.1502",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64 12.21L171.58 21.8",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.42 1.37988L86.5 27.4999",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85 98.4397L143.89 80.6396",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.219 111.88L144.27 95.4502",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 36.5L78.5 8.5",
    stroke: "#FFA94D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5703 17.2497C48.5703 17.2497 54.6903 10.0597 49.3403 2.9297C49.3403 2.9197 43.2203 10.1097 48.5703 17.2497Z",
    fill: "#E8590C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9404 75.3698C61.9404 75.3698 69.5105 83.6298 67.1405 94.4298C64.7805 105.23 54.4205 115.09 54.4205 115.09L29.9404 105.89L44.1605 12.0898C44.1605 12.0898 55.3604 13.5098 56.9604 13.5098C58.5604 13.5098 63.3605 14.2198 63.3605 14.2198V17.0598C63.3605 17.0598 51.4204 19.8998 49.5704 31.9898C47.7204 44.0798 53.4104 68.2598 61.9404 75.3698Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7198 18.49C47.7198 18.49 49.1398 4.27 36.3398 0C36.3398 0 34.9198 14.22 47.7198 18.49Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1106 49.8203L43.7807 53.2703C39.8407 58.1803 51.9906 64.0003 51.9906 64.0003L48.9906 65.4403C48.9906 65.4403 29.2407 58.3103 37.7707 49.7803",
    fill: "#FFA94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6301 86.7505L46.3001 82.4805C46.3001 82.4805 44.8801 100.97 60.5201 108.08C60.5201 108.08 69.7601 101.68 67.6301 86.7505Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5204 95.9902L7.90039 98.1202L28.5204 105.94",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.63 113.05L69.2 123.25V121.78L55.3001 113.36L50.16 110.25C50.16 110.25 49.1401 83.8998 34.9201 86.7498C20.7001 89.5898 26.16 110.25 26.16 110.25L33.49 112.34",
    fill: "#FFA94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3301 108.08L75.5801 110.72V108.08L64.8002 102.97",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9901 13.5098C51.9901 13.5098 49.7501 17.0698 54.4201 21.3298",
    stroke: "#FFA94D",
    strokeWidth: 1.1419,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4907 66.8398C70.7907 68.2698 69.9807 67.9998 71.8207 68.9898C73.1707 69.7198 76.5208 69.4598 76.5208 69.4598V70.9998C76.5208 70.9998 70.0507 72.5299 68.1307 75.3699C66.2007 78.2099 67.6207 86.7498 67.6207 86.7498L60.5107 85.3298L63.3507 69.4698",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8506 51.8998L61.9406 57.9298L64.0006 56.9498C64.0006 56.9498 56.4306 49.7198 49.8606 49.0498",
    fill: "#FFA94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8301 70.4303C66.8301 70.4303 68.6801 63.9903 59.6201 62.5703C59.6201 62.5703 60.3501 69.7603 66.8301 70.4303Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7607 69.6798C70.1529 69.6798 70.4707 69.3619 70.4707 68.9698C70.4707 68.5776 70.1529 68.2598 69.7607 68.2598C69.3686 68.2598 69.0508 68.5776 69.0508 68.9698C69.0508 69.3619 69.3686 69.6798 69.7607 69.6798Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5602 15.6398C55.1953 15.6398 55.7101 15.125 55.7101 14.4898C55.7101 13.8547 55.1953 13.3398 54.5602 13.3398C53.9251 13.3398 53.4102 13.8547 53.4102 14.4898C53.4102 15.125 53.9251 15.6398 54.5602 15.6398Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0601 100.25V114.24L34.21 117.32V102.44L37.0601 100.25Z",
    fill: "#FD7E14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoRightImage);
export default __webpack_public_path__ + "static/media/photoRightImage.a8dbaa8a89445fbcc5fbf1bc07e74078.svg";
export { ForwardRef as ReactComponent };